export default "__VITE_ASSET__BXV8iZSl__"